module.exports = __webpack_public_path__ + "img/cart.c68224ce.svg";